import { FormFieldSize } from './model';

export const name = 'FormField';
export const DEFAULT_FIELD_SIZE: FormFieldSize = 'normal';
